import { Navigate, useLocation } from "react-router";

interface Props {
  to: string;
}

const LegacyRedirect = ({ to }: Props) => {
  const { search, hash } = useLocation();

  return <Navigate to={{ pathname: to, search, hash }} replace />;
};

export default LegacyRedirect;
